import "jquery";
import * as ko from "knockout";
import { CropsApi } from "../apis/CropsApi";
import { GenericCropsViewModel } from "../ViewModels/GenericCropsViewModel";
import { BaseCrop, IBaseCropYear } from "../Models/Crops/BaseCrop";
import { PdfApi } from "../Apis/PdfApi";
import { isEmpty } from "lodash-es";
import { OsrApi } from "../Apis/OsrApi";



export class BaseCropComponent<T extends IBaseCropYear> {
    cropsApi: CropsApi;
    pdfApi: PdfApi;
    osrApi: OsrApi;
    viewModel: GenericCropsViewModel<T>;
    $viewModelAnchor: JQuery;

    constructor($anchor: JQuery) {
        this.pdfApi = PdfApi.getInstance();
        this.cropsApi = CropsApi.getInstance();
        this.osrApi = OsrApi.getInstance();
        this.viewModel = new GenericCropsViewModel<T>();

        this.$viewModelAnchor = $anchor;

        //Binds the viewmodel to the template
        if (this.$viewModelAnchor[0]) {
            ko.applyBindings(this.viewModel, this.$viewModelAnchor[0]);
        }
    }

    /**
     * Starts the component, loads the data and initializes custom filter if any is suppiled.
     * @param data Data array of type T from API.
     * @param urlParam Url parameter to apply custom filtering. If null no filter is applied.
     * @param jquerySelctorToExpand string selector to find JQuery bootstrap element to expand if a custom filter is active.
     */
    init(data: T[], urlParam: string = null, jquerySelctorToExpand: string = null): void {

        const customFilterValue = this.initCustomFilter(urlParam);
        try {
            this.viewModel.completelist(data);
        } catch (e) {
            if (window.location.href.indexOf('debug=true') > 0) {
                console.log(e);
            }
            throw e;
        }

        this.viewModel.loading(false);

        this.expandRowForCustomfilter(customFilterValue, jquerySelctorToExpand);
        this.attachPdfDownloadJquery();
    }

    /**
     * Initializes custom filter if the url parameter has a value. The value is returned.
     * @param urlParam Url parameter to filter upon, if null or empty no filter is applied.
     */
    private initCustomFilter(urlParam: string): string {

        //Read url query to see if a custom filter should be applied
        const url = new URL(window.location.href);
        const urlParamValue = url.searchParams.get(urlParam);

        //Apply filter if cropNo query were supplied.
        if (urlParamValue != null && !isEmpty(urlParamValue)) {

            //Pass a function to filter the subset.
            this.viewModel.customfilterFunction = ((item: T) => {
                return urlParamValue === item.CropNumber;
            });

            //set propperties to declare if a custom filter is active.
            this.viewModel.customFilterQuery(urlParam);
            this.viewModel.customFilters.push(urlParamValue);

        }
        return urlParamValue;
    }

    /**
     * Expands bootstrap collapse if a custom filter is active. 
     * @param customFilterValue The value on which there is filtered upon.
     * @param jquerySelctorToExpand 'JQuery selector to select the bootstrap collapse element to expand.'
     */
    private expandRowForCustomfilter(customFilterValue: string, jquerySelctorToExpand: string): void {

        if (this.viewModel.customFilters().length > 0 && jquerySelctorToExpand != null) {
            //Expand a specific row if the url filter were supplied.
            if (customFilterValue != null && !isEmpty(customFilterValue)) {
                const expandedRow = $(`${jquerySelctorToExpand}:contains(${customFilterValue})`);

                const expandedRowCollapse = expandedRow.parents('.collapse');
                const expandedRowHeader = expandedRowCollapse.siblings('.table-collapse-head');

                //aria-expanded : determines if '+' or 'minus' should be shown. 
                expandedRowHeader.attr('aria-expanded', 'true');

                //What makes the row expand.
                expandedRowCollapse.addClass('show');

            }
        }
    }

    /**
     * Due to Footable is rendering AFTER knockout is bound, no knockout click bindings are going to work inside footable.
     * This "hack" is an ordinary JQuery eventhandler that listens on click.
     */
    private attachPdfDownloadJquery(): void {
        const self = this;
        self.$viewModelAnchor.on('click', '[id *= download]', function (e: any) {
            const id = $(this).attr('id');
            const fileName = $(this).attr('filename');
            const company = $(this).attr('company');
            const entryNo = Number.parseInt(id.split('download')[1]);
            self.pdfApi.downloadFile(entryNo, fileName, company);
        });
    }
}